/**
 * marketingPaths — the public routes that never touch Firestore.
 *
 * Extracted from ExtensionBlockHint (Walter 2026-09-06) when a second banner
 * needed the same test. Both sync hints suppress themselves here: there is no
 * database connection on these pages, so there is nothing to be blocked or
 * stale about, and probing from them only puts red 400s in the console of the
 * PUBLIC landing page.
 */

const MARKETING_RE = /^\/(landing|about|help|privacy|terms|contact)\b/;

export function isMarketingPath(pathname) {
  const p = String(pathname || '');
  return MARKETING_RE.test(p) || p === '/';
}
